"use client";

import { Field } from "@sitecore-jss/sitecore-jss-nextjs";
import { usePathname } from "next/navigation";
import * as AccordionUI from "@repo/ui/accordion";
import { Box } from "@repo/ui/box";
import AccordionItem from "../../../accordion/accordion-item";
import styles from "../../../accordion/accordion.module.css";
import { findSelectedTopic } from "../../utils";
import LinkList from "../link-list/linkList";

export type FaqType = {
  url: { path: string };
  faqTitle: Field<string>;
  shortTitle: Field<string>;
};

export type FaqTopicType = {
  faqTopics: { faqs: FaqType[] };
  heading: Field<string>;
  topicLink: { item: { url: { path: string } } };
};

export type AccordionProps = {
  topics: {
    results: FaqTopicType[];
  };
};

const TopicAccordion = (props: AccordionProps): JSX.Element => {
  const { results } = props.topics;
  const pathname = usePathname();

  if (!results || results.length === 0) {
    return <></>;
  }

  const selectedTopic = findSelectedTopic(results, pathname as string);

  return (
    <Box width="100%" className={styles.accordionContainer} data-testid="box">
      <AccordionUI.Root
        defaultValue={selectedTopic ? (selectedTopic as string) : ""}
        className={styles.helpTopicsAccordion}
      >
        {results.length > 0 &&
          results.map((item, index) => (
            <AccordionItem
              key={index}
              value={item.topicLink.item?.url?.path || ""}
              title={item.heading}
            >
              <LinkList faqs={item.faqTopics.faqs} showArrow={true} />
            </AccordionItem>
          ))}
      </AccordionUI.Root>
    </Box>
  );
};

export default TopicAccordion;
